var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolMagnify = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14 3c6.075 0 11 4.925 11 11s-4.925 11-11 11S3 20.075 3 14 7.925 3 14 3Zm-1.646 3.955c-3.095 0-5.614 2.46-5.614 5.509 0 3.047 2.519 5.509 5.614 5.509l.22-.004a5.658 5.658 0 0 0 2.96-.964l.02-.015 3.022 2.952a1 1 0 0 0 1.414-.016l.082-.095a1 1 0 0 0-.098-1.319l-2.995-2.926.114-.167a5.408 5.408 0 0 0 .875-2.955c0-3.048-2.519-5.51-5.614-5.51Zm0 2c2.001 0 3.614 1.576 3.614 3.509 0 1.932-1.613 3.509-3.614 3.509s-3.614-1.577-3.614-3.51c0-1.932 1.613-3.508 3.614-3.508Z",
  fill: "currentColor",
  fillRule: "evenodd"
})));
export { SvgToolMagnify as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-magnify.svg";